module.exports = "/_next/static/media/firefox-icon.37bd2712.png";